import { Typography } from "@mui/material";
import { access } from "fs";
import { canViewInsights } from "ft-shared-graphql";
import { Step } from "react-joyride";

export const studentInsightsSteps: Record<string, { label: string; steps: Step[] }> = {
    studentInsightsMain: {
        label: "Insights",
        steps: [
            {
                target: '[data-tour="student-insights-header"]',
                content: "As more sessions are run at your company, this dashboard will analyze the answers, giving you insights and trends within your community.",
                data: { route: '/manage/company/students', access: canViewInsights }
            },
            {
                target: '[data-tour="common-themes"]',
                content: "The survey asks many free-form follow up questions. Commonly occuring themes are identified and ranked here.",
                data: { route: '/manage/company/students', access: canViewInsights }
            },
            {
                target: '[data-tour="anxiety-markers"]',
                content: "The survey has a total of 16 anxiety markers, these are not diagnostic, and are represented in correlation with age here.",
                data: { route: '/manage/company/students', access: canViewInsights }
            },
            {
                target: '[data-tour="depression-markers"]',
                content: "The survey has a total of 15 depression markers, these are not diagnostic, and are represented in correlation with age here.",
                data: { route: '/manage/company/students', access: canViewInsights }
            },
        ]
    }

}

